@if (!isHidden) {

<div class="absolute bottom-0 left-0 w-full h-full flex justify-center z-10"
    [class]="displayCookiesSettings ? 'items-center' : 'items-end'">

    <div
        class="cookies-panel backdrop-blur-[30px] rounded-3xl w-[calc(100%-48px)] max-w-[1056px] z-10 py-6 px-8 m-6 text-white flex flex-wrap items-center justify-center flex-col md:flex-row pointer-events-auto h-fit max-h-[calc(100%-48px)] overflow-y-auto hide-scrollbar">

        @if (!displayCookiesSettings) {

        <!-- Left text -->
        <div class="flex-shrink md:min-w-[200px] flex-1 text-xs pr-8 mb-4 md:mb-0 opacity-80">
            <p class="font-bold mb-2 md:text-left text-center">{{translation.getText('cookies', 'title_disclaimer')}}
            </p>
            <p class="md:text-left text-center">{{translation.getText('cookies', 'text_modal')}}
            </p>
        </div>

        <!-- Right buttons -->
        <div class="flex flex-wrap md:flex-nowrap items-center justify-center gap-2 md:gap-4">

            <!-- Accept + Customize -->
            <div class="font-semibold flex items-center gap-2 md:gap-4">
                <button class="btn white uppercase h-8 px-4 whitespace-nowrap text-xs" (click)="acceptCookies()">
                    {{translation.getText('cookies', 'accept_button')}}
                </button>

                <button class="btn white uppercase h-8 px-4 whitespace-nowrap text-xs" (click)="customizeCookies()">
                    {{translation.getText('cookies', 'customize_button')}}
                </button>
            </div>

            <!-- Separator -->
            <div class="hidden md:block w-px h-12 bg-white/50"></div>

            <!-- Reject -->
            <div class="font-semibold flex items-center">
                <button class="btn white uppercase h-8 px-4 whitespace-nowrap text-xs" (click)="rejectCookies()">
                    {{translation.getText('cookies', 'reject_button')}}
                </button>
            </div>

        </div>

        } @else {

        <div class="w-full flex flex-col justify-center items-center relative">
            <button (click)="displayCookiesSettings = false"
                class="absolute top-0 right-0 w-9 h-9 text-white bg-white/30 rounded-full hover:bg-white hover:text-black text-3xl cursor-pointer transition-all duration-300">
                &times;
            </button>
            <h3 class="text-center font-bold mb-6">{{translation.getText('cookies', 'title_modal')}}</h3>

            <div class="max-w-[600px] text-sm">

                <div class="opacity-80">
                    <p class="mb-6 whitespace-pre-line">
                        {{translation.getText('cookies', 'text_modal')}}
                    </p>
                </div>

                <!-- Radio Form -->
                <form>

                    <!-- Necessary -->
                    <div class="mb-6 flex items-start gap-4 md:-ml-7">
                        <input id="cookies-necessary" type="checkbox" class="custom-checkbox" checked disabled />

                        <div>
                            <label for="cookies-necessary"
                                class="font-bold block mb-2 cursor-pointer">{{translation.getText('cookies',
                                'necessary_title_modal')}}</label>
                            <p class="opacity-80">
                                {{translation.getText('cookies', 'necessary_text_modal')}}
                            </p>
                        </div>
                    </div>

                    <!-- Analytics -->
                    <div class="mb-6 flex items-start gap-4 md:-ml-7">

                        <input id="cookies-analytics" type="checkbox" class="custom-checkbox"
                            [checked]="selectedConsent === CookieConsent.Analytics"
                            (change)="onAnalyticsToggle($event)" />

                        <div>
                            <label for="cookies-analytics"
                                class="font-bold block mb-2 cursor-pointer">{{translation.getText('cookies',
                                'analytics_title_modal')}}</label>
                            <p class="opacity-80">
                                {{translation.getText('cookies', 'analytics_text_modal')}}
                            </p>
                        </div>
                    </div>

                </form>

                <!-- Cookie list -->
                <div class="max-h-[24vh] rounded-lg overflow-y-auto bg-white/25 p-6">
                    <dl
                        class="cookie-definition-list grid [grid-template-columns:80px_1fr] sm:[grid-template-columns:96px_1fr] gap-y-0 gap-x-4">

                        <dt>{{translation.getText('cookies', 'cookie_title_table')}}</dt>
                        <dd>_gid</dd>

                        <dt>{{translation.getText('cookies', 'duration_title_table')}}</dt>
                        <dd>1 {{translation.getText('cookies', 'duration_day')}}</dd>

                        <dt>{{translation.getText('cookies', 'description_title_table')}}</dt>
                        <dd>
                            {{translation.getText('cookies', 'description_text1_table')}}
                        </dd>

                        <dt class="mt-4">{{translation.getText('cookies', 'cookie_title_table')}}</dt>
                        <dd class="mt-4">_gat_gtag_UA_*</dd>

                        <dt>{{translation.getText('cookies', 'duration_title_table')}}</dt>
                        <dd>1 {{translation.getText('cookies', 'duration_minute')}}</dd>

                        <dt>{{translation.getText('cookies', 'description_title_table')}}</dt>
                        <dd>{{translation.getText('cookies', 'description_text2_table')}}</dd>

                        <dt class="mt-4">{{translation.getText('cookies', 'cookie_title_table')}}</dt>
                        <dd class="mt-4">_ga_*</dd>

                        <dt>{{translation.getText('cookies', 'duration_title_table')}}</dt>
                        <dd>1 {{translation.getText('cookies', 'duration_year')}} 1 {{translation.getText('cookies',
                            'duration_month')}} 4 {{translation.getText('cookies', 'duration_days')}}</dd>

                        <dt>{{translation.getText('cookies', 'description_title_table')}}</dt>
                        <dd>{{translation.getText('cookies', 'description_text3_table')}}
                        <dt class="mt-4">{{translation.getText('cookies', 'cookie_title_table')}}</dt>
                        <dd class="mt-4">_ga</dd>

                        <dt>{{translation.getText('cookies', 'duration_title_table')}}</dt>
                        <dd>1 {{translation.getText('cookies', 'duration_year')}} 1 {{translation.getText('cookies',
                            'duration_month')}} 4 {{translation.getText('cookies', 'duration_days')}}</dd>

                        <dt>{{translation.getText('cookies', 'description_title_table')}}</dt>
                        <dd>{{translation.getText('cookies', 'description_text4_table')}}
                        </dd>

                    </dl>
                </div>

            </div>

            <!-- Footer buttons -->
            <div class="w-full flex justify-end mt-8">
                <button class="btn white uppercase mr-6 text-xs" (click)="savePreferences()">
                    {{translation.getText('cookies', 'save_preferences_button')}}
                </button>

                <button class="btn white uppercase text-xs" (click)="acceptCookies()">
                    {{translation.getText('cookies', 'accept_button')}}
                </button>
            </div>

        </div>
        }
    </div>

</div>

}